import GenericNoteLinkedGroupAdapter from 'notebook/notes/groups/GenericNoteLinkedGroupAdapter';
import {
  NotePartGridGroupMetadata,
  CreateNotePartGridGroupExtras,
} from 'notebook/notes/groups/note-part-grid/NotePartGridGroupConstants';
import {makeGridPlaceholderNotePart} from 'notebook/notes/groups/note-part-grid/util/gridPlaceholderUtils';
import {
  CreateNoteLinkedGroupProps,
  GroupActionFunctions,
  NoteLinkedGroup,
} from 'notebook/notes/groups/NoteLinkedGroupConstants';
import {NotePart} from 'notebook/util/NoteUtilConstants';
import {Schema} from 'schemas/SchemaConstants';

export class NotePartGridNoteLinkedGroupAdapter extends GenericNoteLinkedGroupAdapter<
  NotePartGridGroupMetadata,
  CreateNotePartGridGroupExtras
> {
  getDisplayName(group: NoteLinkedGroup<NotePartGridGroupMetadata>): string {
    return group.name || 'Grid Viewer';
  }

  override supportsCopyPaste(): boolean {
    return true;
  }

  createNoteParts(
    createProps: CreateNoteLinkedGroupProps<NotePartGridGroupMetadata, CreateNotePartGridGroupExtras>
  ): Array<NotePart> {
    const tasks = createProps.extras.gridImageTasks ?? [];
    return tasks.map(({taskId, fileUploadDeferred, fileName}) =>
      makeGridPlaceholderNotePart(taskId, fileUploadDeferred, fileName)
    );
  }

  getGroupSchemas(_group: NoteLinkedGroup<NotePartGridGroupMetadata>): Array<Schema> {
    return []; // Empty because we don't have any schemas for the grid.
  }

  // Override action functions to be empty since we don't want to show any actions for the grid.
  override getActionFunctions(): GroupActionFunctions<
    NotePartGridGroupMetadata,
    CreateNotePartGridGroupExtras
  > {
    return {primary: undefined, secondary: [], overflow: [], footer: []};
  }
}
